/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by sjacobs on 8/27/18.
 */
function SourceCollaboratorsController(this: JS5Object, ModalService: JS5Object, uiGridConstants: JS5Object) {

    this.$onInit = (): void => {
        this.gridOptions.data = this.editData.emailContacts;
    };

    this.addContact = () => {
        const existingEmailContactIds = _.map(this.editData.emailContacts, 'id');
        ModalService.showContactsSelectModal(existingEmailContactIds, onContactSelected);
    };

    this.removeSelectedContacts = () => {
        const selectedContacts = this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected contact(s)?',
            pullCancelLeft: true,
            title: 'Remove Contact(s)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            _.set(this, 'editData.emailContacts', _.differenceBy(this.editData.emailContacts, selectedContacts, 'id'));
            this.gridOptions.data = this.editData.emailContacts;
            this.editorForm.$setDirty();
        });
    };

    const onContactSelected = (selection: JS5Object) => {
        _.set(this, 'editData.emailContacts', _.unionBy(this.editData.emailContacts, selection, 'id'));
        this.gridOptions.data = this.editData.emailContacts;
        this.editorForm.$setDirty();
    };

    const columnDefinitions = [
        {
            field: 'firstName',
            displayName: 'First Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'lastName',
            displayName: 'Last Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'emailAddress',
            displayName: 'Email Address',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        data: [],
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

}

angular.module('prism-ui.externalMetadata').component('sourceCollaborators', {
    controller: SourceCollaboratorsController,
    templateUrl: 'system/externalMetadata/setup/editor/sourceCollaborators/source-collaborators-template.html',
    bindings: {
        editData: '<'
    }
});
